export const REPORT_TIMINGS = {
    'all_time': 'Since Beginning',
    'year': 'This Year',
    'quarter': 'This Quarter',
    'month': 'This Month',
    'week': 'This Week'
};



// WEBPACK FOOTER //
// ./src/containers/ReportsPage/constants.js